// 261023 E3-P3h R4/R5 (F1) — luật «mỗi bước ĐÚNG MỘT chủ nút đỏ khi còn việc bấm được; hết việc thì 0» khi KHÔNG có dải giữ CTA (truyện làm tay, dải đang chạy). THUẦN.
// `stageCta` (từ `useCtaHolds().holds('stage')`) chỉ cho biết dải KHÔNG giữ; trong cùng một bước có nhiều ứng viên ⇒ các hàm dưới chọn đúng một.
// Nút `primary` bị khoá vẽ XÁM nên chủ đỏ chỉ có nghĩa khi nút BẤM ĐƯỢC: mọi luật dưới đây xét cả trạng thái bấm được, không chỉ «hiện / là nút chính».

export interface SkeletonCtaIn {
  approved: boolean;
  /** Chuỗi «Truyện mới» đang ở chỗ dừng 1 (nút chính ở dải; thẻ chỉ còn nút «chạy tiếp» nếu `cardContinueShow`). */
  stop1: boolean;
  cardContinueShow: boolean;
  cardContinuePrimary: boolean;
  /** Thẻ «Duyệt khung xương / Chốt tổng quan» bấm được (không `busy`, không `blockReason` — vd chưa có tổng quan). */
  cardApproveEnabled: boolean;
  /** Nút «chạy tiếp» của thẻ bấm được (không `busy`, không `continueBlock`). */
  cardContinueEnabled: boolean;
}

/** ②: thẻ duyệt (ngoài các tab nên luôn thấy) giữ đỏ KHI BẤM ĐƯỢC; bị khoá (vd thiếu tổng quan) thì nhường nút «Tạo/Chốt tổng quan» ở tab Tổng quan. */
export const skeletonCardRed = (i: SkeletonCtaIn): boolean =>
  !i.approved && (i.stop1 ? i.cardContinueShow && i.cardContinuePrimary && i.cardContinueEnabled : i.cardApproveEnabled);

/** Nút «Tạo tổng quan» / «Chốt tổng quan» ở tab Tổng quan: đỏ khi bước giữ CTA VÀ thẻ duyệt không đỏ. */
export const overviewHoldsCta = (stageCta: boolean, cardRed: boolean): boolean => stageCta && !cardRed;

export interface SplitCtaIn {
  stageCta: boolean;
  /** Đã có danh sách tập (thẻ dàn tập chỉ có khi đã chia). */
  hasEpisodes: boolean;
  /** `episodePlanCopy(...).action`. */
  planAction: string;
  /** `nsStageApproveButton().primary` — chuỗi STOP 2 hạ nút chốt thành phụ. */
  planBtnPrimary: boolean;
  /** Nút chốt bấm được (không `disabled`, không đang lưu). */
  planEnabled: boolean;
  runEnabled: boolean;
}

/** Nút chốt dàn tập là nút chính (kiểu `primary`), bất kể bấm được hay không — dùng cho `type` của nút. */
export const planIsPrimary = (i: Pick<SplitCtaIn, 'hasEpisodes' | 'planAction' | 'planBtnPrimary'>): boolean =>
  i.hasEpisodes && (i.planAction === 'approve' || i.planAction === 'reapprove') && i.planBtnPrimary;

/** ④: «Chốt dàn tập» (nút chính & bấm được) thắng «Chia tập»; CHƯA có tập nào (không có thẻ dàn tập) ⇒ «Chia tập» đỏ. */
export const splitRedOwners = (i: SplitCtaIn): { run: boolean; plan: boolean } => {
  const plan = i.stageCta && planIsPrimary(i) && i.planEnabled;
  return { plan, run: i.stageCta && !plan };
};
